// utils/utils.js

/**
 * Formata uma data no padrão brasileiro (dd/mm/yyyy).
 * Aceita entrada no formato ISO (yyyy-mm-dd) ou já no formato brasileiro (dd/mm/yyyy).
 */
export const formatarDataBrasil = (dataISO) => {
  if (!dataISO) return "Data Inválida";

  if (dataISO.includes("/")) {
    return dataISO; // Já está no formato brasileiro
  }

  const partes = dataISO.split("-");
  if (partes.length !== 3) return "Data Inválida";

  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
};

/**
 * Formata um número como moeda brasileira (BRL).
 * Exemplo: 1234.56 => "R$ 1.234,56"
 */
export const formatarMoeda = (valor) => {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Formata um número como porcentagem com duas casas decimais.
 * Exemplo: 0.1234 => "12,34%"
 */
export const formatarPorcentagem = (valor) => {
  return `${(Number(valor || 0) * 100).toFixed(2).replace(".", ",")}%`;
};

/**
 * Formata um número padrão brasileiro (com separadores de milhar).
 * Exemplo: 1234567 => "1.234.567"
 */
export const formatarNumero = (valor) => {
  return Number(valor || 0).toLocaleString("pt-BR");
};
